import { api } from '@/api'
import type { BankAccount } from '@/api/typings/bank-account.typing'
import type { ApiResponse } from '@/api/typings/response.typing'

// Payload Interfaces
export interface CreateIranianSrcAccountPayload {
  sheba_number: string
  card_number: string
  bank_name: string
  owner_full_name: string
  national_code: string
  birth_date: string
}

export interface CreateIranianAccountPayload {
  sheba_number: string
  card_number: string
  bank_name: string
  owner_full_name: string
  national_code: string
  birth_date: string
}

export interface CreateInternationalAccountPayload {
  iban_number: string
  bic_number: string
  bank_name: string
  owner_full_name: string
  country_id: string
  sort_code?: string
  account_number?: string
  is_pound?: boolean
}

export interface CreateInternationalRevolutAccountPayload {
  iban_number: string
  bic_number: string
  bank_name: string
  owner_full_name: string
  country_id: string
  revolut_tag: string
}

export interface CreateInternationalPaypalAccountPayload {
  paypal_email: string
  paypal_id?: string
  bank_name: string
  owner_full_name: string
  country_id: string
}
export interface CreateInternationalWiseAccountPayload {
  iban_number: string
  bic_number: string
  bank_name: string
  owner_full_name: string
  country_id: string
  wise_tag?: string
  sort_code?: string
  account_number?: string
  is_pound?: boolean
}

// ----------------------
// Iranian Source Account
export function createIranianSrcAccountAction({
  userId,
  ...payload
}: { userId: string } & CreateIranianSrcAccountPayload): Promise<ApiResponse<BankAccount>> {
  return api.post<ApiResponse<BankAccount>>(`/bank-accounts/${userId}/iranian-src`, payload)
}

// Iranian Destination Account
export function createIranianAccountAction({
  userId,
  ...payload
}: { userId: string } & CreateIranianAccountPayload): Promise<ApiResponse<BankAccount>> {
  return api.post<ApiResponse<BankAccount>>(`/bank-accounts/${userId}/iranian`, payload)
}

// International Account
export function createInternationalAccountAction({
  userId,
  ...payload
}: { userId: string } & CreateInternationalAccountPayload): Promise<ApiResponse<BankAccount>> {
  return api.post<ApiResponse<BankAccount>>(`/bank-accounts/${userId}/international`, payload)
}

// International Revolut Account
export function createInternationalRevolutAccountAction({
  userId,
  ...payload
}: { userId: string } & CreateInternationalRevolutAccountPayload): Promise<ApiResponse<BankAccount>> {
  return api.post<ApiResponse<BankAccount>>(`/bank-accounts/${userId}/international-revolut`, payload)
}

// International Paypal Account
export function createInternationalPaypalAccountAction({
  userId,
  ...payload
}: { userId: string } & CreateInternationalPaypalAccountPayload): Promise<ApiResponse<BankAccount>> {
  return api.post<ApiResponse<BankAccount>>(`/bank-accounts/${userId}/international-paypal`, payload)
}

export function createInternationalWiseAccountAction({
  userId,
  ...payload
}: { userId: string } & CreateInternationalWiseAccountPayload): Promise<ApiResponse<BankAccount>> {
  return api.v2.post<ApiResponse<BankAccount>>(`/bank-accounts/${userId}/international-wise`, payload)
}
